export enum TrackEventType {
    UserClicked = 'User Clicked',
    LoadedPage = 'Loaded a Page',
    ModalOpened = 'Modal Opened',
    ToastOpened = 'Toast Opened',
}
